import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'framework7-react';
import PropTypes from 'prop-types';

export default function ExpandTextPanel(props) {
  const [expandMessage, setExpandMessage] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (
      document.getElementsByClassName('expand-text-panel-content')[0]
        .clientHeight > 40
    ) {
      setExpandMessage(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        margin: props.margin ? `0 ${props.margin}px` : 'inherit'
      }}
      className={
        'expand-text-panel' +
        (expandMessage ? ' expand-on ' : '') +
        (expanded ? ' expanded' : '')
      }
    >
      <div
        id={props.id}
        className={'expand-text-panel-content'}
        onClick={() => setExpanded(!expanded)}
      >
        {props.children ? (
          props.children
        ) : props.html ? (
          <div
            dangerouslySetInnerHTML={{
              __html: props.text
            }}
          />
        ) : (
          props.text
        )}
      </div>

      {expandMessage && (
        <Fragment>
          {!expanded && (
            <div
              className={'gradient-fade-out-bot'}
              style={{
                pointerEvents: 'none',
                position: 'absolute',
                width: '99%',
                height: '40px',
                bottom: 0
              }}
            ></div>
          )}
          <div className={'expand-text-panel-more'}>
            <Link
              onClick={() => setExpanded(!expanded)}
              iconMaterial={expanded ? 'expand_less' : 'expand_more'}
            />
          </div>
        </Fragment>
      )}
    </div>
  );
}

ExpandTextPanel.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  html: PropTypes.bool,
  children: PropTypes.element,
  margin: PropTypes.number
};
